import type { RouteRecordRaw } from 'vue-router'
import type { Component } from 'vue'
import { useFeaturesStore } from '@/v2/store/features'

type PageLoader = () => Promise<Component | { default: Component }>

// Picks the v2 page or the legacy one based on the "jobs-page" feature flag.
// On flag resolution failure — legacy page.
const resolveJobsPage = (legacyLoader: PageLoader, v2Loader: PageLoader) => async () => {
  const featuresStore = useFeaturesStore()
  try {
    await featuresStore.load()
    return featuresStore.isJobsPageEnabled ? v2Loader() : legacyLoader()
  } catch {
    return legacyLoader()
  }
}

const jobsRoutes: RouteRecordRaw[] = [
  {
    path: 'vacancies',
    name: 'vacancies',
    component: resolveJobsPage(
      () => import('@/pages/vacancies/VacanciesPage.vue'),
      () => import('@/v2/pages/jobs/JobsPage.vue')
    ),
    meta: {
      requiresAuth: true,
      background: 'secondary'
    },
    children: [
      {
        path: '',
        name: 'FindAJobTab',
        component: resolveJobsPage(
          () => import('@/pages/vacancies/VacanciesRecommendedPage.vue'),
          () => import('@/v2/pages/jobs/tabs/FindAJobTab.vue')
        ),
        meta: {
          requiresAuth: true
        }
      },
      {
        // Component-less record: v2 tabs render straight into JobsPage's
        // router-view. The legacy VacanciesSavedPage brings its own layout and
        // picks the sub-page by route name, so it acts as the leaf for both tabs.
        path: 'saved',
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: '',
            name: 'SavedSearchesTab',
            component: resolveJobsPage(
              () => import('@/pages/vacancies/VacanciesSavedPage.vue'),
              () => import('@/v2/pages/jobs/tabs/SavedSearchesTab.vue')
            ),
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'favorites',
            name: 'SavedJobsTab',
            component: resolveJobsPage(
              () => import('@/pages/vacancies/VacanciesSavedPage.vue'),
              () => import('@/v2/pages/jobs/tabs/SavedJobsTab.vue')
            ),
            meta: {
              requiresAuth: true
            }
          }
        ]
      }
    ]
  }
]

export default jobsRoutes
